export const isYoutubeLink = (v: string): boolean => {
    try {
        const url = new URL(v)
        return (
            // "youtube.com" を含むホスト名 or "youtu.be"
            url.hostname.includes("youtube.com") || url.hostname === "youtu.be"
        )
    } catch {
        return false
    }
}
